import {
  useRefinementList,
  UseRefinementListProps,
} from "react-instantsearch-core-v7";

// This component is used to create a virtual algolia refinement list
// that is not rendered in the DOM.
// This is necessary so we can prefilter the refinements before they
// are used.
function VirtualRefinementList(props: UseRefinementListProps): null {
  useRefinementList(props);

  return null;
}

export { VirtualRefinementList };
